'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var PropTypes = require('prop-types');
var Link = require('./Link.js');
var jsxRuntime = require('react/jsx-runtime');
require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

({
  /** Url to send the user to when the logo is clicked */
  url: PropTypes__default["default"].string.isRequired,
  /** The source of the image for the logo */
  src: PropTypes__default["default"].string.isRequired,
  /** Alt text for the logo when the user hovers over the component */
  alt: PropTypes__default["default"].string.isRequired,
  /** The width of the logo component */
  width: PropTypes__default["default"].number.isRequired,
  /** The height of the logo component */
  height: PropTypes__default["default"].number.isRequired,
  /** Additional classes for the logo component */
  className: PropTypes__default["default"].string
});
var Logo = function Logo(_ref) {
  var src = _ref.src,
    url = _ref.url,
    alt = _ref.alt,
    width = _ref.width,
    height = _ref.height,
    className = _ref.className;
  return /*#__PURE__*/jsxRuntime.jsx(Link["default"], {
    to: url,
    children: /*#__PURE__*/jsxRuntime.jsx("a", {
      children: /*#__PURE__*/jsxRuntime.jsx("img", {
        src: src,
        alt: alt,
        width: width,
        height: height,
        className: className === null ? undefined : className
      })
    })
  });
};

exports["default"] = Logo;
